import { TabsDesignTokens } from '@primeuix/themes/types/tabs';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const tabOverride: TabsDesignTokens = {
  tab: {
    activeColor: getColor('SeaBlue'),
    color: getColor('SeaBlue'),
    hoverColor: getColor('SeaBlue'),
    padding: `${getRem(20)} 0`,
  },
  activeBar: {
    background: 'none',
  },
  tabpanel: {
    padding: `${getRem(20)} 0`,
  },
};
